import React from 'react';

export interface CantineroIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const CantineroIcon: React.FC<CantineroIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="m12.767 13.487.964 10.498h6.97l1.258-13.703h-9.487zm9.893-4.696H11.819v1.491H22.66z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M21.02 6.39h-7.709l-.84 2.402h9.389zm-1.664-3.642H14.91l-.42 3.641h5.287zM8.569 23.336H7.412l-1.863.648h4.883z"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M8.569 18.722H7.412v4.615H8.57zm-.001-.002H7.412l-4.964-5.234h11.085z"/>
    </svg>
  );
};

export default CantineroIcon;
